import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { ButtonComponent } from '../../buttons/button/button.component';
import { ButtonType } from '../../enum/button-type.enum';
import { InputSize } from '../../enum/input-size.enum';

@Component({
  selector: 'lib-table-no-results',
  imports: [ButtonComponent],
  templateUrl: './table-no-results.component.html',
  styleUrl: './table-no-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableNoResultsComponent {
  adjustFiltersClicked = output();

  protected readonly ButtonType = ButtonType;
  protected readonly InputSize = InputSize;
}
